import optimizely from './optimizely.js'

// The full list of features can be found here: https://app.optimizely.com/v2/projects/19747435253/features. Be aware of using the feature key and NOT the feature name when registering new features in this map ({ NAME_USED_IN_WEB_APP: 'optimizely_feature_key' }).
const FEATURES = Object.freeze({
  dialect: 'FE_languagesDialect',
  customNaming: 'FE_customNaming',
  points: 'FE_points',
  xlsReport: 'FE_xlsReport',
  orgSensitiveSettings: 'FE_orgSensitiveSettings',
  inReviewStatus: 'fe_inreviewstatus',
  downtimeMigration: 'FE_downtimeMigration',
  disableSignupRoute: 'fe_disablesignuproute', // Feature flag for preproduction environment
  integrations: 'fe_integrations',
  plannerBadges: 'FE_plannerBadges',
  aiSummarize: 'FE_aiSummarize',
  aiTasksSuggestion: 'FE_aiTasksSuggestion',
  aiSolutionSuggestion: 'FE_aiSolutionSuggestion',
  usePagerApiKeys: 'FE_usePagerApiKeys',
  createdInFilterForSiteAdminsOnRoutines:
    'fe_createdinfilterforsiteadminsonroutines',
  conditionalLogicInRoutines: 'FE_conditionalLogicInRoutines',
})

function getUserAttrs(account) {
  const userId = account?._id ?? account?.id

  if (!userId) {
    return {}
  }

  return {
    ...account,
    platform: 'web',
    organizationType: account?.organization?.type,
    organizationPlan: account?.organization?.plan,
    organization: account?.organization?._id,
    site: account?.site?._id ?? account?.site,
    userId,
    tags: (account?.tags ?? []).map(attr => attr._id).join(','),
  }
}

export default {
  FEATURES,

  isFeatureEnabled(featureKey, user) {
    const userId = user?._id ?? user?.id
    const attributes = getUserAttrs(user)

    return optimizely.isFeatureEnabled(featureKey, userId, attributes)
  },

  getFeatureVariable(feature, variable, user) {
    const featureKey = FEATURES[feature]
    const userId = user?._id ?? user?.id
    const userAttributes = getUserAttrs(user)

    return optimizely.getFeatureVariable(
      featureKey,
      variable,
      userId,
      userAttributes
    )
  },

  getFeatureParams(feature, user) {
    const featureKey = FEATURES[feature]
    const userId = user?._id ?? user?.id
    const userAttributes = getUserAttrs(user)

    return {
      isEnabled: optimizely.isFeatureEnabled(
        featureKey,
        userId,
        userAttributes
      ),
      variables: optimizely.getAllFeatureVariables(
        featureKey,
        userId,
        userAttributes
      ),
    }
  },

  onReady() {
    return optimizely.onReady()
  },
}
